import { takeLatest, call, put } from 'redux-saga/effects';
import axios from '../axiosConfig';
import {
  addCustomBookingFieldRequest,
  addCustomBookingFieldSuccess,
  addCustomBookingFieldFailure,
} from '../../slices/trip';

function* addCustomBookingFieldWorker({ payload: { tripId, fieldKey, fieldValue } }) {
  try {
    const { data } = yield call(axios, {
      method: 'patch',
      url: `trips/${tripId}/customBookingFields`,
      data: { fieldKey, fieldValue },
    });
    yield put(addCustomBookingFieldSuccess({ tripConfirmation: data }));
  } catch (error) {
    const errorMessage =
      error?.response?.data?.detail ||
      error?.message ||
      'Failed to save the field. Please try again.';
    yield put(addCustomBookingFieldFailure(errorMessage));
  }
}

function* addCustomBookingFieldWatcher() {
  yield takeLatest(addCustomBookingFieldRequest.toString(), addCustomBookingFieldWorker);
}

export default addCustomBookingFieldWatcher;
